import { useTranslation } from "react-i18next";
import IconBot from "@/assets/icons/bot.svg?react";
import IconSearch from "@/assets/icons/search.svg?react";
import { DeepAnalysisType } from "@/stores/ui/useDeepAnalysisStore";
import { TabButton } from "./TabButton";

interface Props {
  analysistype: DeepAnalysisType | undefined;
  setAnalysisType: (type: DeepAnalysisType) => void;
  onClose: () => void;
}

export const DeepAnalysisHeader = (props: Props) => {
  const { analysistype, setAnalysisType, onClose } = props;
  const { t } = useTranslation("voiceek_ui");

  return (
    <div className="flex items-center justify-between rounded-t-[inherit] mb-0.5 h-[72px] px-4 bg-[#293D72]">
      <div className="flex gap-2">
        <TabButton
          isActive={analysistype === DeepAnalysisType.VOC_SEARCH}
          onClick={() => setAnalysisType(DeepAnalysisType.VOC_SEARCH)}
        >
          <IconSearch className="fill-inherit" />
          <span>{t("sidebar.vocSearch")}</span>
        </TabButton>
        <TabButton
          isActive={analysistype === DeepAnalysisType.CHAT}
          onClick={() => setAnalysisType(DeepAnalysisType.CHAT)}
        >
          <IconBot className="fill-inherit" />
          <span>{t("chat.chatBot")}</span>
        </TabButton>
      </div>
      <button
        onClick={onClose}
        className="w-[30px] h-[30px] rounded-full bg-[#50608B] hover:bg-[#6B7BA3] flex items-center hover:cursor-pointer justify-center transition-colors relative"
        aria-label="Close modal"
        data-testid="chat-close-button"
      >
        <div className="w-3 h-3 relative flex items-center justify-center">
          <div className="absolute w-4 h-0.5 bg-white rotate-45" />
          <div className="absolute w-4 h-0.5 bg-white -rotate-45" />
        </div>
      </button>
    </div>
  );
};
